import Vue from 'vue'
import local from './q-components/q-local';
import caller from './q-components/q-caller'
import tools from './q-components/q-tools'
import config from './q-components/q-config'
import staticForms from './q-components/q-static-form'
//Add yours bundles here!
import fa from './bundles/languages/fa'
import en from './bundles/languages/en'
import draggable from 'vuedraggable';
//Add static forms
import bundlesEditor from './views/dashboard/staticForms/bundlesEditor';
import permissionEditor from './views/dashboard/staticForms/permission-editor';
import menuEditor from './views/dashboard/staticForms/menu-editor'
import organizationChart from './views/dashboard/staticForms/organization-chart'
import contentEditor from './views/dashboard/staticForms/content-editor'

Vue.prototype.$delegate = caller.delegate;
Vue.prototype.$service = caller.service;
Vue.prototype.$http = caller.axios;
Vue.prototype.$qt = local.qt;
Vue.prototype.$isRtl = local.qt('direction') === 'rtl';
Vue.prototype.$tools = tools;
Vue.prototype.$forms = staticForms.all;
Vue.prototype.$config = config;

local.add('fa', fa);
local.add('en', en);

Vue.component('q-drag', draggable);

import upload from './components/upload'
Vue.component('q-upload', upload);

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('persian-date-picker', VuePersianDatetimePicker);


staticForms.add('q-bundles-editor', bundlesEditor, Vue);
staticForms.add('q-permission-editor', permissionEditor, Vue);
staticForms.add('q-menu-editor', menuEditor, Vue);
staticForms.add('q-organization-chart', organizationChart, Vue);
staticForms.add('q-content-editor', contentEditor, Vue);

import bpm from './views/dashboard/staticForms/bpm'
staticForms.add('q-process-editor', bpm.processEditor, Vue);

import gama from './views/dashboard/staticForms/gama'
staticForms.add('q-gama-truck-settlement', gama.truckSettlement, Vue);
staticForms.add('q-gama-add-payment', gama.addPayment, Vue);
staticForms.add('q-gama-add-waybill', gama.addWaybill, Vue);
staticForms.add('q-gama-waybill-report', gama.waybillReport, Vue);
staticForms.add('q-payment-account-balance', gama.paymentAccountBalance, Vue);
staticForms.add('q-payment-account-operation', gama.paymentAccountOperation, Vue);
